import { Button, ModalHeader, ModalNext, ModalBody, ModalFooter } from '@jutro/components';
import { useTranslator } from '@jutro/locale';

import styles from './DeletePopup.module.scss';
import messages from './DeletePopup.messages';
import { messages as commonMessages } from '@xengage/gw-platform-translations';

function DeletePopup(props) {
    const translate = useTranslator();
    const { isOpen, onResolve, onReject } = props;

    return (
        <ModalNext isOpen={isOpen} className={styles.deletePopup}>
            <ModalHeader title={messages.deleteTitle} />
            <ModalBody>
                <ul>
                    <li>
                        <span>{translate(messages.deleteBody1_1)}</span> 
                        <span className={styles.bold}>{translate(messages.deleteBody1_2)}</span>
                        <span>{translate(messages.deleteBody1_3)}</span>
                    </li>
                    <li>
                        <span>{translate(messages.deleteBody2_1)}</span> 
                        <span className={styles.bold}>{translate(messages.deleteBody2_2)}</span>
                        <span>{translate(messages.deleteBody2_3)}</span>
                        <span className={styles.bold}>{translate(messages.deleteBody2_4)}</span>
                    </li>
                    <li>
                        <span>{translate(messages.deleteBody3_1)}</span> 
                        <span className={styles.bold}>{translate(messages.deleteBody3_2)}</span>
                        <span>{translate(messages.deleteBody3_3)}</span>
                        <span className={styles.bold}>{translate(messages.deleteBody3_4)}</span>
                        <span>{translate(messages.deleteBody3_5)}</span>
                    </li>
                </ul>
            </ModalBody>
            <ModalFooter>
                <Button
                    onClick={onResolve}
                    label={translate(messages.accept)}
                />
                <Button
                    onClick={onReject}
                    label={translate(commonMessages.cancelModel)}
                    variant="secondary"
                />
            </ModalFooter>
        </ModalNext>
    )
}

export default DeletePopup;
